import { LicenceTypes } from "../../../../api/LicenceDetails";
import { IndustrialEmissionsWasteAppTrackerDesktop } from "./ApplicationTrackers/IndustrialEmissionsWasteAppTrackerDesktop";
import { NoTracker } from "./ApplicationTrackers/NoTracker";
import { WasteWaterAppTrackerDesktop } from "./ApplicationTrackers/WasteWaterAppTrackerDesktop";
import { GetAppTrackerLabel } from "./ApplicationTrackerUtils";
import { ILicenceDetailsProps } from "./ILicenceDatailsProps";
import { MakeSubmissionOrObjection } from "./MakeSubmissionOrObjection";
import { TrackerCard } from "./TrackerCard";

const LicenceApplicationTrackerDesktop = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => {
  let tracker = (<div />) as JSX.Element;

  switch (licence.licencetype) {
    case LicenceTypes.IEL:
    case LicenceTypes.IPC:
    case LicenceTypes.IPPC:
    case LicenceTypes.Waste:
      tracker = (
        <IndustrialEmissionsWasteAppTrackerDesktop
          licence={licence}
          licenceProfile={licenceProfile}
        />
      );
      break;
    case LicenceTypes.WWDA:
    case LicenceTypes.CoA:
      tracker = (
        <WasteWaterAppTrackerDesktop
          licence={licence}
          licenceProfile={licenceProfile}
        />
      );
      break;
    default:
      tracker = <NoTracker licence={licence} licenceProfile={licenceProfile} />;
  }

  return tracker;
};

const LicenceApplicationTrackerV2 = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => {
  return (
    <div>
      <div className="d-lg-none">
        <LicenceApplicationTrackerMobile
          licence={licence}
          licenceProfile={licenceProfile}
        />
      </div>
      <div className="d-none d-lg-block">
        <LicenceApplicationTrackerDesktop
          licence={licence}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

const LicenceApplicationTrackerMobile = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => {
  const bodyElements = (
    <MakeSubmissionOrObjection
      licence={licence}
      licenceProfile={licenceProfile}
    />
  );

  return (
    <TrackerCard
      title={GetAppTrackerLabel({ licence, licenceProfile })}
      content={bodyElements}
    />
  );
};

const LicenceApplicationTracker = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => (
  <LicenceApplicationTrackerV2
    licence={licence}
    licenceProfile={licenceProfile}
  />
);

export default LicenceApplicationTracker;
